import { CUSTOMER_TIMEZONE } from "config/constant";

const pad = (n) => String(n).padStart(2, "0");

const to24h = (s) => {
  const m = String(s).trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (m) {
    let h = +m[1];
    if (m[3].toUpperCase() === "PM" && h !== 12) h += 12;
    if (m[3].toUpperCase() === "AM" && h === 12) h = 0;
    return `${pad(h)}:${pad(m[2])}`;
  }
  return /^\d{1,2}:\d{2}$/.test(s) ? s : null;
};

const to12h = (time24) => {
  const [h, m = 0] = time24.split(":").map(Number);
  return `${h % 12 || 12}:${pad(m)} ${h >= 12 ? "PM" : "AM"}`;
};

const parseSlot = (slot) => {
  if (!slot) return { display: "", toTime24: null };
  const parts = slot.split("-").map((p) => p.trim());
  const end = parts[1] ?? parts[0];
  const fmt = (x) => (/AM|PM/i.test(x) ? x : to12h(x));
  const display = parts[1] ? `${fmt(parts[0])} - ${fmt(parts[1])}` : fmt(parts[0] || "");
  return { display, toTime24: to24h(end) };
};

export const computeFulfillment = (checkoutState) => {
  const { checkoutTimeSlot, isFollowedEbtPayment, savePlaceOrder } = checkoutState || {};
  const now = new Date();
  const offset = -now.getTimezoneOffset();
  const offsetStr = `${offset >= 0 ? "+" : "-"}${pad(Math.floor(Math.abs(offset) / 60))}${pad(Math.abs(offset) % 60)}`;
  const source = isFollowedEbtPayment ? savePlaceOrder : checkoutTimeSlot;
  const hasSlot = source?.shipping_date && source?.shipping_time;
  const shipping_date = hasSlot ? source.shipping_date : now.toISOString().slice(0, 10);
  const slot = hasSlot ? source.shipping_time : `${pad(now.getHours())}:00-${pad((now.getHours() + 1) % 24)}:00`;
  const { display, toTime24 } = parseSlot(slot);
  const endTime = toTime24 || `${pad(now.getHours())}:${pad(now.getMinutes())}`;

  return {
    fulfillment_date: `${shipping_date}T${endTime}:00.000${offsetStr}`,
    shipping_date,
    shipping_time: display,
    timezone: CUSTOMER_TIMEZONE,
  };
};
